import { FC, useCallback, useState } from 'react';
import { Client } from '@utilities/types';
import { AddClientForm, Button, Icon, Modal } from '@components';
import { formatDate } from '@utilities/functions';

interface Props {
    client: Client;
    onEdit: (clientId: string, client: Client) => void;
    onDelete: (clientId: string) => void;
}

export const ClientCard: FC<Props> = ({ 
    client, 
    onEdit, 
    onDelete,
}) => {

    const [isOpenModal, setIsOpenModal] = useState<boolean>(false);

    const onToggleEditModal = useCallback(()=> {
        setIsOpenModal((prev) => !prev);
    }, []);

    const handleEditClientInfos = useCallback((clientData: Partial<Client>) => {
        const updatedClient = {
            ...client,
            ...clientData,
        };
        onEdit(client._id, updatedClient);
    }, [client, onEdit]);

    return (
        <>
            <div className="border rounded-lg shadow-sm p-4 bg-white space-y-2 overflow-hidden">
                <div className="flex justify-between items-center">
                    <div>
                        <h3 className="text-lg font-bold text-primary">
                            {client.firstname} {client.lastname}
                        </h3>
                        <p className="text-sm text-gray-600">
                            Né(e) le : {formatDate(client.birth)}
                        </p>
                    </div>
                    <span className="text-sm bg-blue-100 text-blue-800 px-2 py-1 rounded-full">
                        {client.points} points
                    </span>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 text-sm text-gray-700">
                    {client.phoneNumber && <p><strong>Téléphone :</strong> {client.phoneNumber}</p>}
                    {client.email && <p><strong>Email :</strong> {client.email}</p>}
                    {client.city && <p><strong>Ville :</strong> {client.city}</p>}
                    {client.country && <p><strong>Pays :</strong> {client.country}</p>}
                </div>

                <div className="flex justify-end gap-2 pt-2">
                    <Button
                        variant="warning"
                        onClick={onToggleEditModal}
                    >
                        <Icon iconName="Pencil" size={18} /> Modifier
                    </Button>

                    <Button
                        variant="error"
                        onClick={() => onDelete(client._id)}
                    >
                        <Icon iconName="Trash2" size={18} /> Supprimer
                    </Button>
                </div>
            </div>

            <Modal
                isOpen={isOpenModal}
                onClose={onToggleEditModal}
                title="Modifier le client"
            >
                <AddClientForm
                    client={client}
                    onCreateClient={handleEditClientInfos}
                    onCancel={onToggleEditModal}
                />
            </Modal>
        </>
    );
};
